import React, { useState, useRef } from "react";
import { Form, Col, Row, InputGroup, Button } from "react-bootstrap";
import "./Form.css";
import { useFormik } from "formik";
import { useQueryClient } from "react-query";
import { useNavigate, useLocation } from "react-router-dom";
import { AlbumSchema } from "./Schemas";
import { toast } from "react-toastify";

import { PatchAxios, PostAxios } from "../../../helper/AxiosHelper";
const AlbumForm = ({ edit }) => {
  const baseURL = process.env.REACT_APP_FILE_URL;
  const location = useLocation();
  const client = useQueryClient();
  const navigate = useNavigate();
  const imageRef = useRef(null);
  const [images, setImages] = useState("");
  function handleImageClick(e) {
    imageRef.current.click();
  }
  function handleImageChange(e) {
    const file = e.target.files[0];
    setImages(file);
  }
  const handlePost = async (e) => {
    const formData = new FormData();

    for (const key in values) {
      if (key === "image") {
        continue;
      }
      formData.append(key, values[key]);
    }
    if (!edit) {
      if (InitialState.image instanceof File) {
        formData.append("image", InitialState.image);
      } else {
        formData.append("image", InitialState.image);
      }
    } else {
      if (edit && images instanceof File) {
        formData.append("image", images);
      } else {
        formData.append("image", InitialState.image);
      }
    }
    const res = edit
      ? await PatchAxios(`/admin/album/${location.state._id}`, formData)
      : await PostAxios("/admin/album", formData);
    if (res.success) {
      navigate("/admin/album");
      toast.success(edit ? "Updated Successfully" : "Added Successfully");
      client.refetchQueries("AlbumList");
    } else {
      toast.error(res.message);
    }
  };

  const InitialState = {
    title: edit ? location.state.title : "",
    image: edit ? location.state.image : images,
  };
  const {
    isSubmitting,
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    isValid,
  } = useFormik({
    initialValues: InitialState,
    validationSchema: AlbumSchema,
    onSubmit: async (values, action) => {
      console.log(values);
      const res = await handlePost();
      if (res) {
        action.resetForm();
      }
    },
  });
  return (
    <>
      <Form>
        <h2 className="text-center text-muted mb-2">Add album</h2>

        <Row className="m-2 p-2">
          <Col md={6}>
            <Form.Group>
              <Form.Label htmlFor="name">
                Title
                <span className="text-danger">*</span>
              </Form.Label>
              <InputGroup hasValidation>
                <Form.Control
                  required
                  type="text"
                  placeholder="Title"
                  name="title"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.title}
                />
              </InputGroup>
              {errors.title && touched.title ? (
                <p className="text-danger">{errors.title}</p>
              ) : null}
            </Form.Group>
          </Col>
          <div className="image_holder">
            {!images ? (
              <img
                src={
                  edit && InitialState.image
                    ? `${baseURL}/${InitialState.image}`
                    : "https://media.istockphoto.com/id/1248723171/nl/vector/camera-pictogram-van-het-foto-uploaden-op-ge%C3%AFsoleerde-witte-achtergrond-eps-10-vector.jpg?s=612x612&w=0&k=20&c=WLTMjPeoFbET0aBnnJmLyzDE1wUkJu9nj07KPtmf8qg="
                }
                className="rounded-circle"
                alt="Cinque Terre"
                height={200}
                width={200}
                onClick={handleImageClick}
              />
            ) : (
              <img
                src={URL.createObjectURL(images)}
                alt="albumInput"
                className="rounded-circle"
                height={200}
                width={200}
                onClick={handleImageClick}
              />
            )}
            <input
              type="file"
              ref={imageRef}
              accept="image/*"
              onChange={handleImageChange}
            />
          </div>
          <div className="mt-4 d-flex justify-content-between">
            <Button
              type="submit"
              className={`btn btn-primary  `}
              onClick={handleSubmit}
              disabled={!isValid || isSubmitting}
            >
              {edit
                ? isSubmitting
                  ? "Updating...."
                  : "Update"
                : isSubmitting
                ? "Submitting...."
                : "Submit"}
            </Button>
            <Button
              type="button"
              className="btn btn-danger "
              onClick={() => {
                navigate(-1);
              }}
            >
              Cancel
            </Button>
          </div>
        </Row>
      </Form>
    </>
  );
};

export default AlbumForm;
